export const TRANSCRIPTION_LANGUAGES = [
  { id: "auto", label: "Detect automatically" },
  { id: "en", label: "English" }, { id: "te", label: "తెలుగు · Telugu" },
  { id: "hi", label: "हिन्दी · Hindi" }, { id: "ta", label: "தமிழ் · Tamil" },
  { id: "kn", label: "ಕನ್ನಡ · Kannada" }, { id: "ml", label: "മലയാളം · Malayalam" },
  { id: "mr", label: "मराठी · Marathi" }, { id: "bn", label: "বাংলা · Bengali" },
  { id: "gu", label: "ગુજરાતી · Gujarati" }, { id: "pa", label: "ਪੰਜਾਬੀ · Punjabi" },
  { id: "ur", label: "اردو · Urdu" }, { id: "as", label: "অসমীয়া · Assamese" },
  { id: "ne", label: "नेपाली · Nepali" }, { id: "sa", label: "संस्कृतम् · Sanskrit" },
  { id: "sd", label: "سنڌي · Sindhi" },
];

export const LANGUAGE_NAMES = {
  en: "English", te: "Telugu", hi: "Hindi", ta: "Tamil", kn: "Kannada", ml: "Malayalam",
  mr: "Marathi", bn: "Bengali", gu: "Gujarati", pa: "Punjabi", ur: "Urdu", as: "Assamese",
  or: "Odia", ne: "Nepali", sa: "Sanskrit", sd: "Sindhi",
};

export const LANGUAGE_LABELS = {
  en: "English", te: "తెలుగు", hi: "हिन्दी", ta: "தமிழ்", kn: "ಕನ್ನಡ", ml: "മലയാളം",
  mr: "मराठी", bn: "বাংলা", gu: "ગુજરાતી", pa: "ਪੰਜਾਬੀ", ur: "اردو", as: "অসমীয়া",
  or: "ଓଡ଼ିଆ", ne: "नेपाली", sa: "संस्कृतम्", sd: "سنڌي",
};